module.exports = __webpack_public_path__ + "static/media/bookmark.266267bc.png";